import React, { useContext, useState, useRef, useEffect } from 'react';
import './TopBar.css';
import { deleteService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import { useAuth } from '../../../auth/AuthContext';
import { SidebarContext } from '../Sidebar/SidebarContext';
import { getRoleDisplayName } from '../../../utility/RolesUtility';
const getBase64FromUrl = async (url: string) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
const TopBar: React.FC = () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const [menuOpen, setMenuOpen] = useState(false);
    const { logout } = useAuth();
    const { openMenu } = useContext(SidebarContext);
    const { isSidebarCollapsed, toggleSidebar } = useContext(SidebarContext);
    // const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    console.log("Sidebar state before:", isSidebarCollapsed);
    const menuRef = useRef<HTMLDivElement>(null); // Create a ref for the menu
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const [tooltip, setTooltip] = useState<string | null>(null);

    const logoutMethod=async () =>{
        let res = await deleteService(API_ENDPOINTS.logout);
        console.log(res);
        logout();
    
        window.location.href = "/login"
    }
    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setMenuOpen(false);
        }
    };
    const [profilePicBase64, setProfilePicBase64] = useState<string | null>(null);
    useEffect(() => {
        if (userInfo?.profilePic?.documentUrl) {
            // Check if Base64 is already stored, else fetch the image and convert it
            if (!userInfo?.profilePic?.base64Str) {
              getBase64FromUrl(userInfo?.profilePic?.documentUrl).then((base64Str) => {
                userInfo.profilePic.base64Str = base64Str; // Update userInfo with base64
                localStorage.setItem('userInfo', JSON.stringify(userInfo));
                console.log(base64Str);
                
                setProfilePicBase64(base64Str);
              });
            } else {
              setProfilePicBase64(userInfo.profilePic.base64Str); // Load from localStorage if already available
            }
          }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        
    }, []);
    return (
        
        <header className={`main-header flex justify-between bg-white fixed w-full mr-4 sm:mr-0 ${!isSidebarCollapsed ? 'lg:w-[82.1vw]' : 'lg:w-[93vw]' }  pt-0 px-[30px] pb-[12px] items-center z-30`}>
{/*           
            <div
    className="relative left-[-48px] top-[39px] flex items-center justify-center w-[30px] h-[30px] rounded-full border-2 border-gray-300 bg-white shadow-md cursor-pointer"
    onClick={toggleSidebar}
    onMouseEnter={() => setTooltip(isSidebarCollapsed ? "Expand Menu" : "Collapse Menu")} // Show tooltip on hover
    onMouseLeave={() => setTooltip(null)} // Hide tooltip on hover
>
   
    {tooltip && (
        <div className="absolute left-full ml-2 text-xs font-normal font-Inter text-white bg-[#111827] py-1 px-2 rounded-md shadow-md whitespace-nowrap">
            {tooltip}
            <div
                className="absolute right-full top-1/2 transform -translate-y-1/2"
                style={{
                    width: 0,
                    height: 0,
                    borderRight: '7px solid black',
                    borderTop: '7px solid transparent',
                    borderBottom: '7px solid transparent',
                }}
            />
        </div>
    )}
    <div className="flex">
        <img
            className={`transform transition-transform duration-300 w-[6px] ${
                !isSidebarCollapsed ? 'rotate-180' : ''
            }`}
            src="/images/rightArrow.svg"
            alt="Arrow"
        />
        <img
            className={`transform transition-transform duration-300 w-[6px] ${
                !isSidebarCollapsed ? 'rotate-180' : ''
            }`}
            src="/images/rightArrow.svg"
            alt="Arrow"
        />
    </div>
</div> */}


            <div>
                <img
                    className="text-start mt-4 flex justify-start sm:hidden"
                    src="/images/menu.png"
                    height="45"
                    width="45"
                    alt="Menu"
                    onClick={openMenu}
                />
            </div>
            <nav className="navbar navbar-static-top">
                <div className="flex rightSec text-center mt-5 mr-3 mb-5 sm:mb-0">
                <div className='flex items-center'>
                            {/* <img
                                className="cursor-pointer mr-5"
                                src="/images/notificationIcon.svg"
                                alt="User"
                               
                            /> */}
                        </div>
                    <div className="relative">
                        <div className='flex items-center'  onClick={toggleMenu}>
                            <img
                                className="userIcon cursor-pointer mr-3"
                                src={profilePicBase64 ? profilePicBase64 : '/images/userImg.svg'}
                                alt="User"
                            />
                          <div>
                        <div className='flex items-center'>
                        <span className='text-sm text-gray-800 font-bold'>{userInfo?.firstName} {userInfo?.lastName}</span>
                            
                            <img
                                className="cursor-pointer ml-2 "
                                src="/images/Chevron down.svg"
                                alt="User"
                               
                            />
                        </div>
                             <p className='text-gray-400 font-semibold text-[10px] text-left'>{getRoleDisplayName(userInfo?.roles)}</p>
                          </div>
                        </div>
                       
                        {menuOpen && (
                            <div ref={menuRef} className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10 bottom-[-42px]">
                                <button
                                    className="w-full text-center px-4 py-2 text-black hover:bg-gray-100"
                                    onClick={logoutMethod}
                                >
                                    Logout
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default TopBar;
